import { useA, useQ } from './hooks'
import type { Item, Out } from './generated/types'

export const NotificationsA = {
  my: 'notifications.my',
  markRead: 'notifications.mark_read',
} as const

export type StaffNotification = Item<Out<'notifications.my'>>

export const useMyNotifications = (enabled = true) => useQ(NotificationsA.my, { limit: 50 }, { enabled, refetchInterval: 60_000 })
export const useMarkRead = () => useA(NotificationsA.markRead)

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined)

/**
 * SPA link for a notification, from its data (task_id, visit_id, draft_id, journey_id …).
 * The backend's own `data.url` uses paths like /tasks/{id} that the SPA maps to query params.
 */
export function notificationHref(n: Pick<StaffNotification, 'kind' | 'data'>): string | undefined {
  const d = n.data ?? {}
  const task = str(d.task_id)
  if (task) return `/tasks?task=${task}`
  if (str(d.visit_id) && (n.kind.startsWith('ai_') || str(d.draft_id))) return `/doctor/visits/${str(d.visit_id)}`
  if (str(d.journey_id)) return `/journeys/${str(d.journey_id)}`
  if (str(d.conversation_id)) return `/inbox?c=${str(d.conversation_id)}`
  if (str(d.booking_request_id)) return '/admin/client-app'
  if (str(d.insight_id) || n.kind === 'insight_published') return '/insights'
  if (n.kind === 'low_rating_alert') return '/quality'
  if (n.kind === 'sync_alert') return '/admin/system'
  const url = str(d.url)
  if (url?.startsWith('/finance')) {
    const date = str(d.date)
    return date ? `/finance?from=${date}&to=${date}&tab=flags` : '/finance'
  }
  if (str(d.pet_id)) return `/pets/${str(d.pet_id)}`
  if (str(d.client_id)) return `/clients/${str(d.client_id)}`
  if (url?.startsWith('/')) return url
  return undefined
}
